<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header position-relative"
  >
    <!-- Content Left -->
    <b-col
      v-if="breadcrumbTitle"
      class="content-header-left mb-2"
      cols="12"
      md="9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-50 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <!-- O icone fica ao lado do TITULO, nao no fim da trilha: e onde a
               pessoa procura por "o que esta tela quer dizer". -->
          <b-button
            v-if="$route.meta.info"
            :id="sanitizedInfoId"
            variant="flat"
            class="btn-icon p-0 float-left content-header-info"
            :title="$route.meta.infoTitle || 'Como ler esta tela'"
            :aria-label="$route.meta.infoTitle || 'Como ler esta tela'"
            @click="modalInfo($route.meta.pageTitle, $route.meta.info)"
          >
            <feather-icon
              icon="InfoIcon"
              size="16"
              class="text-muted cursor-pointer"
            />
          </b-button>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Ações da tela, na linha do título. O `.right-button` abaixo não serve: é absoluto e sobe para a navbar. -->
    <b-col
      class="content-header-actions d-flex align-items-center justify-content-md-end mb-2"
      cols="12"
      md="3"
    >
      <portal-target name="breadcrumb-right" />
    </b-col>

    <!-- Content Right -->

    <b-col
      class="content-header-right text-md-right d-md-block d-none mb-1 right-button"
      cols="12"
    >
      <slot />
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import getInfo from "@/helpers/info";
import useAppConfig from "@core/app-config/useAppConfig";

export default {
  props: {
    breadcrumbTitle: {
      type: Boolean,
      default: () => true,
    },
  },
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
  },
  setup() {
    const { skin } = useAppConfig();

    return { skin };
  },
  computed: {
    /**
     * O id do botão de informação.
     *
     * Era o HTML INTEIRO do conteúdo sanitizado — 10.413 caracteres de atributo
     * `id` no DOM em toda rota com `meta.info`, e nada o consome. Agora é o
     * nome da rota.
     */
    sanitizedInfoId() {
      return `header-info-${this.$route.name || 'page'}`;
    }
  },
  methods: {
    getInfo,

    modalInfo(title, html) {
      this.$swal({
        backdrop: true,
        title: `Seja bem-vindo(a) à tela de ${title}!`,
        html: html,
        icon: "info",
        confirmButtonText: "Ok",
        // Fechar sem atrito. Estavam os dois em `false`, entao so o botao "Ok"
        // fechava — e num conteudo de 12 mil caracteres isso obriga a rolar ate
        // o fim para sair.
        allowOutsideClick: true,
        allowEscapeKey: true,
        // A largura e responsiva por CSS (`.modal-height`, em style.scss), e nao
        // aqui: computada em JS ela e lida UMA vez na abertura e nao reage a um
        // redimensionamento com o modal aberto.
        width: "60vw",
        heightAuto: false,
        background: `${this.skin === "dark" ? "#283046" : ""}`,
        customClass: {
          popup: "modal-height",
          confirmButton: "btn btn-primary",
          title: "text-primary",
          htmlContainer: `announcement-body info-responsive ${
            this.skin === "dark" ? "text-white" : ""
          }`,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.popover {
  white-space: pre-wrap;
  max-width: 600px;
}

.right-button {
  position: absolute;
  top: -3.5rem;
  right: 0;
}
</style>

<style scoped>
/* O ícone acompanha a linha de base do título, sem empurrar a trilha. */
.content-header-info {
  margin-top: 2px;
}
</style>
